<template>
  <div class="bg-grey-lines block-fullscreen">
    <div class="header-logo">
      <icon name="td-logo" color="#393f49" />
    </div>
    <section class="block-fullscreen-center block-fullscreen-text">
      <div class="title-float">
        <span>I</span>
        <span>N</span>
        <span>T</span>
        <span>R</span>
        <span>O</span>
      </div>
      <div class="title-main">
        <h1>
          Olá, {{username}}
        </h1>
        <p>
          Neste teste vamos ajudar você a identificar o seu nível de maturidade digital.
        </p>
        <p>
          O Score será calculado com base em cinco dimensões principais: Cultura e Liderança, Agilidade Operacional, Tecnologia Digital, Experiência do Cliente e Empreendedorismo Digital.
        </p>
        <p>
          Vamos lá!
        </p>
      </div>
      <router-link to="/teste/cultura-e-lideranca" class="nav-arrow-down">
        <div class="title hidden-sm">
          Inicie o diagnóstico
        </div>
        <icon name="arrow-line-right" class="arrow-right animation-blink" />
      </router-link>
    </section>
  </div>
</template>

<script>
import Icon from '../Icon';
import rollDown from '../mixins/rollDown';

/* eslint-disable max-len */
export default {
  name: 'intro',
  mixins: [rollDown],
  components: { Icon },
  data() {
    return {
      nextScreen: '/teste/cultura-e-lideranca',
      username: this.$store.state.username
    };
  },
  mounted() {
    this.$store.commit('SET_BAR_PROGRESS', 1);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/test/Intro.vue